import { useEffect } from "react";

import { useFormantClientContext } from "@formant/rectangle-sdk";
import { useAppStore } from "@formant/rectangle-sdk/src/store";

import { UrlParamService } from "../services/UrlParamService";

export const useUrlParamSync = () => {
    const {
        selectedDateRange,
        isPlaying,
        isLive,
        selectedTimeRange,
        selectedPlaybackModifier,
        selectedSeekModifier,
        aggregateTimeRange,
        selectedDate,
    } = useAppStore(
        "selectedDateRange",
        "isPlaying",
        "isLive",
        "selectedTimeRange",
        "selectedPlaybackModifier",
        "selectedSeekModifier",
        "aggregateTimeRange",
        "selectedDate",
    );

    const { selectedTags, globalFilter } = useFormantClientContext();

    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }

        try {
            UrlParamService.updateParams({ selectedTags });
        } catch (error) {
            console.error(
                "[useUrlParamSync] Error updating selectedTags:",
                error,
            );
        }
    }, [selectedTags]);

    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }
        try {
            if (globalFilter && Object.keys(globalFilter).length > 0) {
                UrlParamService.updateParams({ globalFilter });
            }
        } catch (error) {
            console.error(
                "[useUrlParamSync] Error updating globalFilter:",
                error,
            );
        }
    }, [globalFilter]);

    // Sync selectedDate with URL
    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }

        try {
            if (!isLive && selectedDate) {
                UrlParamService.updateParams({ selectedDate });
            }
            if (isLive) {
                UrlParamService.removeParams(["selectedDate"]);
            }
        } catch (error) {
            console.error(
                "[useUrlParamSync] Error updating selected date:",
                error,
            );
        }
    }, [selectedDate, isLive]);

    // Update URL when parameters change
    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }

        try {
            if (!isLive && selectedDateRange[0] && selectedDateRange[1]) {
                UrlParamService.updateParams({
                    startDate: selectedDateRange[0],
                    endDate: selectedDateRange[1],
                });
            }
            if (isLive) {
                UrlParamService.removeParams(["startDate", "endDate"]);
            }
        } catch (error) {
            console.error(
                "[useUrlParamSync] Error updating date range:",
                error,
            );
        }
    }, [selectedDateRange]);

    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }

        try {
            UrlParamService.updateParams({ isPlaying });
        } catch (error) {
            console.error("[useUrlParamSync] Error updating isPlaying:", error);
        }
    }, [isPlaying]);

    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }

        try {
            UrlParamService.updateParams({ isLive });
        } catch (error) {
            console.error("[useUrlParamSync] Error updating isLive:", error);
        }
    }, [isLive]);

    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }

        try {
            if (selectedTimeRange) {
                UrlParamService.updateParams({ timeRange: selectedTimeRange });
            }
        } catch (error) {
            console.error(
                "[useUrlParamSync] Error updating time range:",
                error,
            );
        }
    }, [selectedTimeRange]);

    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }

        try {
            if (selectedPlaybackModifier) {
                UrlParamService.updateParams({
                    playbackSpeed: selectedPlaybackModifier,
                });
            }
        } catch (error) {
            console.error(
                "[useUrlParamSync] Error updating playback speed:",
                error,
            );
        }
    }, [selectedPlaybackModifier]);

    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }

        try {
            if (selectedSeekModifier) {
                UrlParamService.updateParams({ seekBy: selectedSeekModifier });
            }
        } catch (error) {
            console.error("[useUrlParamSync] Error updating seek by:", error);
        }
    }, [selectedSeekModifier]);

    useEffect(() => {
        if (!UrlParamService.isEnabled()) {
            return;
        }

        try {
            if (aggregateTimeRange) {
                UrlParamService.updateParams({
                    aggregateStartDate: new Date(aggregateTimeRange.start),
                    aggregateEndDate: new Date(aggregateTimeRange.end),
                    aggregateTimescale: aggregateTimeRange.timescale || null,
                });
                if (aggregateTimeRange.timescale === null) {
                    UrlParamService.removeParams(["aggregateTimescale"]);
                }
            }
        } catch (error) {
            console.error(
                "[useUrlParamSync] Error updating aggregate time range:",
                error,
            );
        }
    }, [aggregateTimeRange]);
};
